import { render, staticRenderFns } from "./caitable.vue?vue&type=template&id=243708f0&scoped=true"
import script from "./caitable.vue?vue&type=script&lang=js"
export * from "./caitable.vue?vue&type=script&lang=js"
import style0 from "./caitable.vue?vue&type=style&index=0&id=243708f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243708f0",
  null
  
)

export default component.exports